import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Force favicon at runtime to bypass stubborn browser cache.
(() => {
  const href = `/Asy_transfer_logo.png?v=${Date.now()}`;
  const existing = document.querySelectorAll(
    "link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']",
  );
  existing.forEach((el) => el.remove());
  ["icon", "shortcut icon", "apple-touch-icon"].forEach((rel) => {
    const link = document.createElement("link");
    link.setAttribute("rel", rel);
    link.setAttribute("href", href);
    link.setAttribute("type", "image/png");
    document.head.appendChild(link);
  });
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
